import { render, staticRenderFns } from "./app_management.vue?vue&type=template&id=98935492&style=true"
import script from "./app_management.vue?vue&type=script&lang=js"
export * from "./app_management.vue?vue&type=script&lang=js"
import style0 from "./app_management.vue?vue&type=style&index=0&id=98935492&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports